import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const partnumberAdapter = createEntityAdapter({})

const initialState = partnumberAdapter.getInitialState()

export const partnumberApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getpartnumber: builder.query({
            query: () => ({
                url: '/partnumber',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedpartnumber = responseData.map(partnumber => {
                    // console.log(brandmaster)
                    partnumber.id = partnumber._id
                    // console.log(brandmaster)
                    return partnumber
                });
                return partnumberAdapter.setAll(initialState, loadedpartnumber)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'PARTNUMBER', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'PARTNUMBER', id }))
                    ]
                } else return [{ type: 'PARTNUMBER', id: 'LIST' }]
            }
        }),
        addNewpartnumber: builder.mutation({
            query: initialUserData => ({
                url: '/partnumber',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'PARTNUMBER', id: "LIST" }
            ]
        }),        
        updatepartnumber: builder.mutation({
            query: initialUserData => ({
                url: '/partnumber',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'PARTNUMBER', id: arg.id }
            ]
        }),        
        deletepartnumber: builder.mutation({
            query: ({ id }) => ({
                url: `/partnumber`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'PARTNUMBER', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetpartnumberQuery,
    useAddNewpartnumberMutation,
    useUpdatepartnumberMutation,
    useDeletepartnumberMutation 
} = partnumberApiSlice

// returns the query result object
export const selectpartnumberResult = partnumberApiSlice.endpoints.getpartnumber.select()

// creates memoized selector
const selectpartnumberData = createSelector(
    selectpartnumberResult,
    partnumberResult => partnumberResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllpartnumber,
    selectById: selectpartnumberById,
    selectIds: selectpartnumberIds
    // Pass in a selector that returns the users slice of state
} = partnumberAdapter.getSelectors(state => selectpartnumberData(state) ?? initialState)